import { render, staticRenderFns } from "./BlogMarketingIdeasForLocalRestaurants.vue?vue&type=template&id=19cdcf11"
import script from "./BlogMarketingIdeasForLocalRestaurants.vue?vue&type=script&lang=js"
export * from "./BlogMarketingIdeasForLocalRestaurants.vue?vue&type=script&lang=js"
import style0 from "./BlogMarketingIdeasForLocalRestaurants.vue?vue&type=style&index=0&id=19cdcf11&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports